import React from "react";
import {Color, iconColorClasses} from "./iconUtil";

/* eslint-disable max-len */
export default function PresenterIcon({color, size}: {color: Color; size?: number}) {
    return (
        <svg
            width={size || 10}
            height={size || 10}
            className={iconColorClasses(color)}
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="5" cy="2.5" r="2.5" fill="currentColor"/>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 10C9 7.79086 7.20914 6 5 6C2.79086 6 1 7.79086 1 10C1 10.0016 1 10.0032 1 10.0048V10H9Z"
                fill="currentColor"
            />
        </svg>
    );
}
